import { NgRxAction } from '@stop-counter/store';
import { PostItem, PostType } from '@apps/api-interfaces';

export enum Actions {
  LOAD = '[Posts] LOAD Requested',
  LOAD_SINGLE = '[Post] LOAD Requested',
  LOAD_SUCCESS = '[Posts] LOAD Success',
  ERROR = '[Posts] Error'
}

export class LoadAction extends NgRxAction<PostType> {
  type = Actions.LOAD;
}
export class LoadSingleAction extends NgRxAction<string> {
  type = Actions.LOAD_SINGLE;
}
export class LoadSuccessAction extends NgRxAction<PostItem[]> {
  type = Actions.LOAD_SUCCESS;
}
export class ErrorAction extends NgRxAction<any> {
  type = Actions.ERROR;
}

export type ActionType =
  | LoadAction
  | LoadSingleAction
  | LoadSuccessAction
  | ErrorAction;
